import { Component, OnInit } from '@angular/core';
import { AdhesionEnLigneResourceService } from 'src/app/api/adhesion-en-ligne-resource.service';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { AdhesionEnLigneNoAuthResourceService } from '@com.sofaxis/sofaxis-fonpel-espace-elus-ws-ts';
import { KeycloakService } from 'keycloak-angular';

@Component({
    selector: 'app-accesibilite',
    templateUrl: './accesibilite.component.html',
    styleUrls: ['./accesibilite.component.scss']
})
export class AccesibiliteComponent implements OnInit {
    constructor( private keycloackService: KeycloakService, public media: MediaObserver ) {
    }
    estAuthentifie = false;
    async ngOnInit() {
      this.isLoggedIn();
    }

    public isLoggedIn() {
        return this.keycloackService.isLoggedIn().then(( loggin: boolean ) => this.estAuthentifie = loggin);
    }
    


}